"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCatalogueMetadataForProviderType = void 0;
var _constants = require("../constants");
const getCatalogueMetadataForProviderType = (catalogueMetadata)=>catalogueMetadata === null || catalogueMetadata === void 0 ? void 0 : catalogueMetadata.find((catalogue)=>catalogue.providerType === _constants.CATALOGUE_PROVIDER_TYPE);
exports.getCatalogueMetadataForProviderType = getCatalogueMetadataForProviderType;
